

function Diad(a, b) {
    if (Array.isArray(a) && a.length === 2 && b === void 0) {
        this.a = a[0];
        this.b = a[1];
    } else {
        this.a = a;
        this.b = b;
    }
}

Object.assign(Diad.prototype, {
    isDiad: true,
    joiner: '_'
});

Diad.prototype.toString = function () {
    return this.getValues().join(this.joiner);
};

Diad.prototype.asKey = function () {
    return this.toString();
};

Diad.prototype.getValues = function () {
    const values = [this.a, this.b];
    values.sort();
    return values;
};

Diad.prototype.equals = function (other) {
    if (!other || !other.isDiad) {
        return false;
    }
    return (this.a === other.a && this.b === other.b)
        || (this.a === other.b && this.b === other.a);
};

module.exports = Diad;

